import { render, staticRenderFns } from "./BrandProducts.vue?vue&type=template&id=483c495b&scoped=true&"
import script from "./BrandProducts.vue?vue&type=script&lang=js&"
export * from "./BrandProducts.vue?vue&type=script&lang=js&"
import style0 from "./BrandProducts.vue?vue&type=style&index=0&id=483c495b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c495b",
  null
  
)

component.options.__file = "BrandProducts.vue"
export default component.exports